import videojs from 'video.js';
import getIconDelete from '../templates/delete.svg.html';

const dom = videojs.dom || videojs;

const ModalDialog = videojs.getComponent('ModalDialog');

class ModalDialogWithImage extends ModalDialog {
	constructor(player, options) {
		const componentClassName = 'vjs-chat-modal-dialog-with-image';

		super(
			player,
			videojs.mergeOptions(
				options,
				{
					content: getContent(componentClassName)
				}
			)
		);

		this.imageOriginalSizes = {
			width: 0,
			height: 0
		};

		this.componentClassName = componentClassName;

		this.addClass(this.componentClassName);
		this.addListeners_();
	}

	addListeners_() {
		this.on('click', (event) => {
			if (event.target.closest(`.${this.componentClassName}__close`)) {
				this.close();
			}
		});

		this.player().on('playerresize', () => {
			this.setPositionButtonClose();
		});
	}

	open({ imageSrc, width, height }) {
		super.open();

		const closeModalButton = this.getChild("closeButton");

		if (closeModalButton) {
			closeModalButton.hide();
		}

		this.imageOriginalSizes = { width, height };

		const imageClassName = `${this.componentClassName}__image`;

		let oldImageEl = this.$(`.${imageClassName}`);
		if (oldImageEl) {
			oldImageEl.parentNode.removeChild(oldImageEl);
		}

		let containerEl = this.$(`.${this.componentClassName}__container`);
		dom.setAttribute(containerEl, 'data-orientation', width > height ? 'horizontal' : 'vertical');

		let image = dom.createEl('img', {
			className: imageClassName
		}, {
			src: imageSrc
		});

		dom.appendContent(containerEl, image);

		this.setPositionButtonClose();
	}

	setPositionButtonClose() {
		const containerEl = this.$(`.${this.componentClassName}__container`);
		const buttonCloseEl = this.$(`.${this.componentClassName}__close`);

		if (!containerEl || !buttonCloseEl) {
			return;
		}

		const imageWidthOriginal = this.imageOriginalSizes.width;
		const imageHeightOriginal = this.imageOriginalSizes.height;

		const containerWidth = containerEl.clientWidth;
		const containerHeight = containerEl.clientHeight;

		const containerRatioW = containerWidth / containerHeight;
		const imageRatioW = imageWidthOriginal / imageHeightOriginal;

		const containerRatioH = containerHeight / containerWidth;
		const imageRatioH = imageHeightOriginal / imageWidthOriginal;

		const imageWidth = containerRatioW < imageRatioW ? containerWidth : containerWidth * (imageRatioW / containerRatioW);
		const imageHeight = containerRatioH < imageRatioH ? containerHeight : containerHeight * (imageRatioH / containerRatioH);

		const imageX = (containerWidth - imageWidth) / 2;
		const imageY = (containerHeight - imageHeight) / 2;

		const positionAdjustment = 10;

		buttonCloseEl.style.left = `${imageX + imageWidth - positionAdjustment}px`;
		buttonCloseEl.style.top = `${imageY - positionAdjustment}px`;
	}
}

function getContent(componentClassName) {
	let container = dom.createEl('div', {
		className: `${componentClassName}__container`
	});
	let buttonClose = dom.createEl('button', {
		innerHTML: getIconDelete({ width: 10, height: 10 }),
		className: `${componentClassName}__close`
	});
	dom.appendContent(container, buttonClose);
	return container;
}

export { ModalDialogWithImage };
